import { createAction, props } from '@ngrx/store';

import { AppError } from '../errors/app-error';
import { CreateBookmarkProblemListRequest, CreateBookmarkProblemListResponse } from '../models/create-bookmark-problem-list';
import {
  BookmarkProblemList,
  BookmarkProblemListTableData,
  FindMyBookmarkProblemListParams,
  FindSharedBookmarkProblemListParams
} from '../models/bookmark-problem-list';
import {
  AddProblemToBookmarkProblemListResponse,
  ToggleProblemToFromBookmarkProblemListRequest
} from '../models/add-problem-to-bookmark-problem-list';
import { DeleteProblemFromBookmarkProblemListResponse } from '../models/delete-problem-from-bookmark-problem-list';
import { UpdateBookmarkProblemListRequest, UpdateBookmarkProblemListResponse } from '../models/update-bookmark-problem-list';
import { DeleteBookmarkProblemListResponse } from '../models/delete-bookmark-problem-list';
import { Problems } from '../models/problem';
import { CopyBookmarkProblemListResponse } from '../models/copy-bookmark-problem-list';
import { ReorderBookmarkProblemListProblemsRequest } from '../models/reorder-bookmark-problem-list-problems';

// 自分のお気に入りリストの検索 ----------------------------------------------------------------
export const findMyBookmarkProblemLists = createAction(
  '[Bookmark Problem List] Find My Bookmark Problem Lists',
  props<FindMyBookmarkProblemListParams>()
);
export const findMyBookmarkProblemListsSuccess = createAction(
  '[Bookmark Problem List] Find My Bookmark Problem Lists Success',
  props<{ bookmarkProblemLists: BookmarkProblemListTableData[] }>()
);
export const findMyBookmarkProblemListsFailure = createAction('[Bookmark Problem List] Find My Bookmark Problem Lists Failure');
export const initializeFindMyBookmarkProblemListsState = createAction(
  '[Bookmark Problem List] Initialize Find My Bookmark Problem Lists State'
);

// 共有されているお気に入りリストの検索 ----------------------------------------------------------------
export const findSharedBookmarkProblemLists = createAction(
  '[Bookmark Problem List] Find Shared Bookmark Problem Lists',
  props<FindSharedBookmarkProblemListParams>()
);
export const findSharedBookmarkProblemListsSuccess = createAction(
  '[Bookmark Problem List] Find Shared Bookmark Problem Lists Success',
  props<{ sharedBookmarkProblemLists: BookmarkProblemListTableData[] }>()
);
export const findSharedBookmarkProblemListsFailure = createAction('[Bookmark Problem List] Find Shared Bookmark Problem Lists Failure');
export const initializeFindSharedBookmarkProblemListsState = createAction(
  '[Bookmark Problem List] Initialize Find Shared Bookmark Problem Lists State'
);

// 問題をお気に入りリストに登録 ------------------------------------------------------------
export const toggleProblemToFromBookmarkProblemList = createAction(
  '[Bookmark Problem List] Toggle Problem To / From Bookmark Problem List',
  props<ToggleProblemToFromBookmarkProblemListRequest>()
);
export const addProblemToBookmarkProblemListSuccess = createAction(
  '[Bookmark Problem List] Add Problem To Bookmark Problem List Success',
  props<{ response: AddProblemToBookmarkProblemListResponse }>()
);
export const addProblemToBookmarkProblemListFailure = createAction(
  '[Bookmark Problem List] Add Problem To Bookmark Problem List Failure',
  props<{ error: AppError }>()
);
export const initializeAddProblemToBookmarkProblemListState = createAction(
  '[Bookmark Problem List] Initialize Add Problem To Bookmark Problem List State'
);

// APIの処理の結果をメッセージで表示 ------------------------------------------------------------
export const dispatchToggleProblemResultMessage = createAction('[Bookmark Problem List] Dispatch Toggle Problem Success / Failure Message');

// 問題をお気に入りリストから削除 ------------------------------------------------------------
export const deleteProblemFromBookmarkProblemListSuccess = createAction(
  '[Bookmark Problem List] Delete Problem From Bookmark Problem List Success',
  props<{ response: DeleteProblemFromBookmarkProblemListResponse; isListIdMatched?: boolean; problemId: string }>()
);
export const deleteProblemFromBookmarkProblemListFailure = createAction(
  '[Bookmark Problem List] Delete Problem From Bookmark Problem List Failure',
  props<{ error: AppError }>()
);
export const initializeDeleteProblemFromBookmarkProblemListState = createAction(
  '[Bookmark Problem List] Initialize Delete Problem From Bookmark Problem List State'
);

// 未分類のお気に入りリストの問題数をプラス１する （ステートの操作）--------------------------------------------
export const addProblemCount = createAction('[Bookmark Problem List] Add Problem Count', props<{ listId: string }>());
export const addProblemCountSuccess = createAction('[Bookmark Problem List] Add Problem Count Success');

// 未分類のお気に入りリストの問題数をマイナス１する （ステートの操作）------------------------------------------
export const subtractProblemCount = createAction('[Bookmark Problem List] subtract Problem Count', props<{ listId: string }>());
export const subtractProblemCountSuccess = createAction('[Bookmark Problem List] subtract Problem Count Success');

// 新規リストを追加する（ステートの操作）--------------------------------------------------------------------
export const addBookmarkProblemList = createAction(
  '[Bookmark Problem List] Add Bookmark Problem List',
  props<{ bookmarkProblemList: BookmarkProblemList }>()
);
export const addBookmarkProblemListSuccess = createAction('[Bookmark Problem List] Add Bookmark Problem List Success');

// 新規リストの仮IDを実際のIDに置き換える（ステートの操作）----------------------------------------------------
export const updateBookmarkProblemListId = createAction(
  '[Bookmark Problem List] Update Bookmark Problem List ID',
  props<{ tempId: string; realId: string }>()
);
export const updateBookmarkProblemListIdSuccess = createAction('[Bookmark Problem List] Update Bookmark Problem List ID Success');

// 新規リストを削除する（ステートの操作）--------------------------------------------------------------------
export const deleteBookmarkProblemListOnState = createAction(
  '[Bookmark Problem List] Delete Bookmark Problem List On State',
  props<{ tempId: string }>()
);
export const deleteBookmarkProblemListOnStateSuccess = createAction(
  '[Bookmark Problem List] Delete Bookmark Problem List On State Success'
);

// findBookmarkProblemListProblemIds
export const findBookmarkProblemListProblemIds = createAction(
  '[Bookmark Problem List] Find Bookmark Problem List Problem Ids',
  props<{ bookmarkProblemListId: string }>()
);
export const findBookmarkProblemListProblemIdsSuccess = createAction(
  '[Bookmark Problem List] Find Bookmark Problem List Problem Ids Success',
  props<{ bookmarkProblemListProblemIds: string[] }>()
);
export const findBookmarkProblemListProblemIdsFailure = createAction(
  '[Bookmark Problem List] Find Bookmark Problem List Problem Ids Failure'
);
export const initializeFindBookmarkProblemListProblemIdsState = createAction(
  '[Bookmark Problem List] Initialize Find Bookmark Problem List Problem Ids State'
);

// 新規お気に入りリストの作成 ------------------------------------------------------------
export const createBookmarkProblemList = createAction(
  '[Bookmark Problem List] Create Bookmark Problem List',
  props<CreateBookmarkProblemListRequest>()
);
export const createBookmarkProblemListSuccess = createAction(
  '[Bookmark Problem List] Create Bookmark Problem List Success',
  props<{ response: CreateBookmarkProblemListResponse }>()
);
export const createBookmarkProblemListFailure = createAction(
  '[Bookmark Problem List] Create Bookmark Problem List Failure',
  props<{ error: AppError }>()
);
export const initializeCreateBookmarkProblemListState = createAction(
  '[Bookmark Problem List] Initialize Create Bookmark Problem List State'
);

// お気に入りリストの編集 ------------------------------------------------------------
export const updateBookmarkProblemList = createAction(
  '[Bookmark Problem List] Update Bookmark Problem List',
  props<UpdateBookmarkProblemListRequest>()
);
export const updateBookmarkProblemListSuccess = createAction(
  '[Bookmark Problem List] Update Bookmark Problem List Success',
  props<{ response: UpdateBookmarkProblemListResponse }>()
);
export const updateBookmarkProblemListFailure = createAction(
  '[Bookmark Problem List] Update Bookmark Problem List Failure',
  props<{ error: AppError }>()
);
export const initializeUpdateBookmarkProblemListState = createAction(
  '[Bookmark Problem List] Initialize Update Bookmark Problem List State'
);

// お気に入りリストの複製 ------------------------------------------------------------
export const copyBookmarkProblemList = createAction(
  '[Bookmark Problem List] Copy Bookmark Problem List',
  props<{ bookmarkProblemListId: string }>()
);
export const copyBookmarkProblemListSuccess = createAction(
  '[Bookmark Problem List] Copy Bookmark Problem List Success',
  props<{ response: CopyBookmarkProblemListResponse }>()
);
export const copyBookmarkProblemListFailure = createAction(
  '[Bookmark Problem List] Copy Bookmark Problem List Failure',
  props<{ error: AppError }>()
);
export const initializeCopyBookmarkProblemListState = createAction('[Bookmark Problem List] Initialize Copy Bookmark Problem List State');

// お気に入りリストの削除 ------------------------------------------------------------
export const deleteBookmarkProblemList = createAction('[Bookmark Problem List] Delete Bookmark Problem List', props<{ id: string }>());
export const deleteBookmarkProblemListSuccess = createAction(
  '[Bookmark Problem List] Delete Bookmark Problem List Success',
  props<{ response: DeleteBookmarkProblemListResponse }>()
);
export const deleteBookmarkProblemListFailure = createAction(
  '[Bookmark Problem List] Delete Bookmark Problem List Failure',
  props<{ error: AppError }>()
);
export const initializeDeleteBookmarkProblemListState = createAction(
  '[Bookmark Problem List] Initialize Delete Bookmark Problem List State'
);

// お気に入りリストに登録されている問題の取得 ------------------------------------------------------------
export const findBookmarkProblemListProblems = createAction(
  '[Bookmark Problem List] Find Bookmark Problem List Problems',
  props<{ bookmarkProblemListId: string }>()
);
export const findBookmarkProblemListProblemsSuccess = createAction(
  '[Bookmark Problem List] Find Bookmark Problem List Problems Success',
  props<{ problems: Problems }>()
);
export const findBookmarkProblemListProblemsFailure = createAction('[Bookmark Problem List] Find Bookmark Problem List Problems Failure');
export const initializeFindBookmarkProblemListProblemsState = createAction(
  '[Bookmark Problem List] Initialize Find Bookmark Problem List Problems State'
);

// お気に入りリストに登録されている問題の並び順変更 --------------------------------------------------------
export const reorderBookmarkProblemListProblems = createAction(
  '[Bookmark Problem List] Re-order Bookmark Problem List Problems',
  props<ReorderBookmarkProblemListProblemsRequest>()
);
export const reorderBookmarkProblemListProblemsSuccess = createAction(
  '[Bookmark Problem List] Re-order Bookmark Problem List Problems Success',
  props<{ response: { success: boolean }; problemIds: string[] }>()
);
export const reorderBookmarkProblemListProblemsFailure = createAction(
  '[Bookmark Problem List] Re-order Bookmark Problem List Problems Failure'
);
export const initializeReorderBookmarkProblemListProblemsState = createAction(
  '[Bookmark Problem List] Initialize Re-order Bookmark Problem List Problems State'
);

// お気に入りリストに登録されている問題の印刷用データの取得 --------------------------------------------------------
export const findBookmarkProblemListProblemImages = createAction(
  '[Bookmark Problem List] Find Bookmark Problem List Problem Images',
  props<{ bookmarkProblemListId: string }>()
);
export const findBookmarkProblemListProblemImagesSuccess = createAction(
  '[Bookmark Problem List] Find Bookmark Problem List Problem Images Success',
  props<{ problems: Problems }>()
);
export const findBookmarkProblemListProblemImagesFailure = createAction(
  '[Bookmark Problem List] Find Bookmark Problem List Problem Images Failure'
);
export const initializeFindBookmarkProblemListProblemImagesState = createAction(
  '[Bookmark Problem List] Initialize Find Bookmark Problem List Problem Images State'
);
